import { createAction } from '@ngrx/store';
import { httpError, payload } from 'ish-core/utils/ngrx-creators';
import { DotCmsContentDepth } from '../../services/dot-cms-resource/dot-cms-resource.service';

export const loadDotCmsConfigurableContent = createAction(
  '[DOTCMS Content API] load dotcms Configurable Content',
  payload<{ contentKey: string }>()
);

export const loadDotCmsConfigurableContentSuccess = createAction(
  '[DOTCMS Content API] load dotcms Configurable Content Success',
  payload<{
    contentKey: string;
    identifier: string;
    depth?: DotCmsContentDepth;
  }>()
);

export const loadDotCmsConfigurableContentFail = createAction(
  '[DOTCMS Content API] load dotcms Configurable Content Fail',
  httpError()
);
